'use strict';
const model = {
	mainList : $('.js-characteristicField__main'),
	listContent : $('.js-characteristicField__content'),
	defaultHeight : 0,
	show(id) {
		const $item = $(`.js-characteristicField__main[data-id="${id}"]`);
		this.defaultHeight = $item.height();
		$item.animate({
			maxHeight: $item.find('.characteristicField__content').height() + 'px'
		}, 300);
	},
	hide(id) {
		const $item = $(`.js-characteristicField__main[data-id="${id}"]`);
		$item.animate({
			maxHeight: this.defaultHeight + 'px'
		}, 300);
	}

}

$(document).on('click', '.js-characteristicField__moreBtn', function() {
	$(this).toggleClass('current');
	if ($(this).hasClass('current')) {
		model.show($(this).data('id'));
	} else {
		model.hide($(this).data('id'));
	}
});